var React = require('react');

function BrandPromiseNavigate (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m14.9 23.4h22.9v-14.2h-22.9l-11.4 7.1z","style":{"fill":"none","stroke":"#f1b860","strokeWidth":"4","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10"},"key":0}),React.createElement("path",{"d":"m62.7 23.4h-22.9v14.3h22.9l11.4-7.2z","style":{"fill":"none","stroke":"#2a2d58","strokeWidth":"4","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10"},"key":1}),React.createElement("path",{"d":"m49 72h-5.1v-67.7c0-2-2.1-3.5-4.6-3.5s-4.6 1.6-4.6 3.5v67.7h-5.1c-2.2 0-4 1.8-4 4s1.8 4 4 4h19.4c2.2 0 4-1.8 4-4s-1.8-4-4-4z","fill":"#2a2d58","key":2})]);
}

BrandPromiseNavigate.defaultProps = {"enableBackground":"new 0 0 78.4 79.5","viewBox":"0 0 78.4 79.5"};

module.exports = BrandPromiseNavigate;

BrandPromiseNavigate.default = BrandPromiseNavigate;
